<template>
    <tr>
        <td class="p-3">{{ lapMutation.product.name }}</td>
        <td class="p-3">{{ lapMutation.product.article_code }}</td>
        <td class="p-3">{{ formatLap(lapMutation.previous_lap)  }}</td>
        <td class="p-3">{{ formatDate(lapMutation.previous_lap_datetime) }}</td>

        <td class="p-3 nowrap">
            <template v-if="!isDeclined">{{ formatChange(lapMutation.final_change) }}</template>
            <counter v-else
                     :can-be-negative="true"
                     :can-be-user-friendly="true"
                     :value.sync="newChange"
                     :need-format="true"
                     :step="step(allowDecimals)"/>

            <input type="hidden" :name="`change[${lapMutation.id}]`" v-model="newChange">
        </td>

        <td class="p-3">{{ formatLap(finalLap) }}</td>

        <td :class="{'p-3': !isDeclined}">
            <template v-if="!isDeclined">{{ formatDate(lapMutation.final_lap_datetime) }}</template>
            <div v-else class="datepicker-container">
                <date-picker :config="datePickerOptions"
                             :name="`date[${lapMutation.id}]`"
                             :placeholder="formattedNewLapDateTime"
                             :value="newLapDateTime"
                             @dp-change="updateNewLapDateTime"
                             autocomplete="off"
                             class="form-control bg-white date input-field datetimepicker height-30px"/>
            </div>
        </td>

        <td class="p-3">{{ lapMutation.serial_number }}</td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isApproved}" @click="approve">
                <i class="fa fa-check"></i>
            </span>

            <input type="hidden" :name="`approved[${lapMutation.id}]`" :value="approved ? 1 : 0">
        </td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isDeclined}" @click="decline">
                <i class="fa fa-times"></i>
            </span>
        </td>

        <td class="reviewer-details">
            <div class="row">
                <div class="col-4">
                    <div>
                        <strong>Gebruiker ingevoerd:</strong> {{ createdBy }}
                    </div>
                    <div class="mt-2">
                        <strong>Datum/tijd ingevoerd:</strong> {{ formatDateTime(lapMutation.created_at) }}
                    </div>
                </div>

                <div class="col-4">
                    <div>
                        <strong>Controle 1:</strong> {{ checkedFirstTimeBy }}
                    </div>
                    <div class="mt-2">
                        <strong>Datum/tijd goedkeuring:</strong>
                        <span v-if="lapMutation.checked_first_time_at">
                            {{ formatDateTime(lapMutation.checked_first_time_at) }}
                        </span>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment';
    import DatePicker from 'vue-bootstrap-datetimepicker';
    import Counter from '../Counter'

    export default {
        name: 'FuelLapMutationsReviewalTableRow',

        components: {
            Counter,
            DatePicker
        },

        props: {
            lapMutation: Object,
            allowDecimals: Boolean
        },

        data() {
            return {
                datePickerOptions: {
                    minDate: new Date(),
                    showClear: true,
                    useCurrent: false,
                },
                approved: null,
                newChange: this.lapMutation.final_change,
                newLapDateTime: moment(this.lapMutation.final_lap_datetime)
            };
        },

        computed: {
            createdBy() {
                if (!this.lapMutation.created_by) {
                    return ''
                }

                return this.formatName(this.lapMutation.created_by.first_name, this.lapMutation.created_by.last_name)
            },

            checkedFirstTimeBy() {
                if (!this.lapMutation.checked_first_time_by) {
                    return ''
                }

                return this.formatName(this.lapMutation.checked_first_time_by.first_name,
                    this.lapMutation.checked_first_time_by.last_name)
            },

            finalLap() {
                let change = this.isDeclined ? this.newChange : this.lapMutation.final_change;

                return this.lapMutation.previous_lap + change;
            },

            formattedNewLapDateTime() {
                return this.formatDate(this.newLapDateTime || this.lapMutation.final_lap_datetime)
            },

            isApproved() {
                return this.approved === true
            },

            isDeclined() {
                return this.approved === false
            },

            isReviewed() {
                let isChangeReviewed = parseFloat(this.lapMutation.final_change) !== parseFloat(this.newChange);
                let isLapDateTimeReviewed =
                    this.formatDate(this.lapMutation.final_lap_datetime) !== this.formattedNewLapDateTime;

                return this.isApproved || isChangeReviewed || isLapDateTimeReviewed;
            }
        },

        methods: {
            step: (allowDecimals) => allowDecimals ? 0.1 : 1,

            formatChange: (change) => (change > 0 ? '+': '') + change.toFixed(1).replace('.', ','),

            formatLap: (float) => parseFloat(float).toFixed(2).replace('.', ','),

            formatDate: (date) => (typeof date === 'object' ? date : moment(date)).format('L'),

            formatDateTime: (date) => (typeof date === 'object' ? date : moment(date)).format('DD/MM/YYYY H:mm'),

            formatName: (firstName, lastName) => ((firstName || '') + ' ' + (lastName || '')).trim(),

            approve() {
                this.approved = true;
            },

            decline() {
                this.approved = false
            },

            updateNewLapDateTime(value) {
                this.newLapDateTime = value ? value.date : this.lapMutation.final_lap_datetime;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .datepicker-container {
        position: relative;
    }

    td {
        white-space: nowrap;
    }

    td.reviewer-details {
        display: table-row-group;
        padding-bottom: 0.8rem;
        padding-left: 1rem;
        padding-right: 1rem;
        position: absolute;
        transform: translate3d(0, 100%, 0);
    }

    tr {
        height: 135px;
    }
</style>
